module.exports = __webpack_public_path__ + "static/media/filter.6ae11226.svg";